export default __webpack_public_path__ + "static/Maax-Bold-024bf76a405e6495e3f7454363c68e2e.woff2";